function isObjectEmpty<T>(obj: T): boolean {
  if (!obj) return true;
  return Object?.keys(obj as object)?.length === 0;
}

async function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), ms);
  });
}

function getInitialsFromName(name?: string): string {
  if (!name) return '';

  const words = name.trim().split(/\s+/);

  if (words.length === 1) {
    // Single word: take first character
    return words[0].charAt(0).toUpperCase();
  }
  // Multiple words: take first character of first and last word
  const firstChar = words[0].charAt(0).toUpperCase();
  const lastChar = words[words.length - 1].charAt(0).toUpperCase();
  return firstChar + lastChar;
}

function capitalizeFirstLetter(str: string): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const isBrowser = typeof window !== 'undefined' && typeof navigator !== 'undefined';

function arrayWithoutDuplicates<T>(arr: T[]) {
  return Array.from(new Set(arr));
}

function normalizeLanguageCode(appLang: string): string {
  if (!appLang) return 'en';

  const normalized = appLang.toLowerCase();

  return normalized.startsWith('fr') ? 'fr' : 'en';
}

function safeJsonParse<T = unknown>(value: unknown): T {
  if (typeof value !== 'string') return value as T;

  try {
    return JSON.parse(value) as T;
  } catch {
    return value as T;
  }
}

function buildFullName(title?: string, firstName?: string, lastName?: string) {
  const parts = [
    title?.trim() ? `${title.trim()}.` : undefined,
    firstName?.trim(),
    lastName?.trim(),
  ];

  return parts.filter(Boolean).join(' ');
}

const truncateText = (text: string, maxLength: number) => {
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const normalizeEmail = (email: string) => email.trim().toLowerCase();

const isValidEmail = (email: string) => EMAIL_REGEX.test(normalizeEmail(email));

export {
  isBrowser,
  arrayWithoutDuplicates,
  isObjectEmpty, delay, getInitialsFromName, capitalizeFirstLetter,
  EMAIL_REGEX, normalizeEmail, isValidEmail,
  normalizeLanguageCode, safeJsonParse, buildFullName, truncateText,
};
